import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter } from '@angular/core';
import { ApiService } from "../api.service";
import { CommonService} from "../common.service";
import { ActivatedRoute, Router } from "@angular/router";

declare var jQuery: any;
declare var $: any;
declare var Stack: any;


@Component({
  selector: 'app-course-learning-question',
  templateUrl: './course-learning-question.component.html',
  styleUrls: ['./course-learning-question.component.css',]
})
export class CourseLearningQuestionComponent implements OnInit, AfterViewInit {

  @Input() lessonIndex: any;
  @Input() videoIndex: any;
  @Input() questionIndex: any;
  @Input() course: any;
  @Input() lesson: any;
  @Input() learningPathId: any;
  @Input() pathName: string;
  @Output() onExit = new EventEmitter<any>();
  @Output() onGoToNextLesson = new EventEmitter<any>();
  @Output() onGoToNextQuestion = new EventEmitter<any>();
  @Output() onResetLessonStatus = new EventEmitter<any>();
  @Output() onResetQuestionStatus = new EventEmitter<any>();

  learningPath: any;
  learningPathMetaId: any;

  backface: any; // 背面

  startPosition:number;
  endPosition:number;

  currentNumber: number;
  allQuestionsNumber: number;
  slideAble: boolean;

  krisna:any;
  cardIndex: number;

  firstEntry: boolean;
  setCurrentNumber: boolean;
  nextQuestionTrigger: boolean;
  enterFromPre: boolean;

  cardItems: any;

  status: any;
  userType: string;

  completed: boolean;
  moreQuestions: boolean;
  morePreQuestions: boolean;

  transitionText: string;

  singleChoiceAnimate: boolean;
  multipleChoiceAnimate: boolean;
  slideAnimate: boolean;

  // 计算卡片高度
  currentCardHeight: number;
  currentTextHeight: number;
  minHeight: number;
  maxHeight: number;

  preLength: number;
  postLength: number;
  preCompleted: boolean;

  noteStatus: boolean;

  ajaxAnswer: any;

  questionNumberListOpen:boolean;
  goPracticeFlag:boolean; //是否显示情景模拟入口

  mode: number;
  chuanjie: any;
  // 问题
  questions: any;
  // card1Question: any;
  // card2Question: any;
  // 问题组
  questionsGroup:any;
  onSubmitClick: boolean;

  isShowTitle: boolean = false;
  isShowLoadingComponent: boolean;
  assetsRoute: string = "../../assets";

  constructor(private  apiService: ApiService,
              private commonService: CommonService,
              private route: ActivatedRoute,
              private router: Router) { }

  ngOnInit() {

    console.log('question:'+this.pathName);
    this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
    setTimeout(()=>{
      this.isShowLoadingComponent = true;
    },5000);
    this.userType = window.sessionStorage.getItem('userType');
    // 模式
    // console.log(this.course.lessons[0].questionsGroup[0].questions[0].content);
    this.mode = 1;
    let that = this;
    // this.questionIndex = 0;
    this.moreQuestions = false;
    this.morePreQuestions = false;
    this.preCompleted = false;
    this.enterFromPre = false;
    this.onSubmitClick = false;
    // 初始化问题
    this.questionsInit();

    this.apiService.ajax({
      'type': 'post',
      'url': '/api/getUserInfo',
      'data': {}
    }).subscribe(result => {this.status = result;});

    /*this.status = 1;*/
    this.apiService.ajax({
      'type': 'get',
      'url': '/api/concatenation/' + this.learningPathId,
      'data': {
        'learningPathId': this.learningPathId,
      }
    }).subscribe(comment => {
      comment.forEach(function (item,index) {
          if(item.title=='课程学习'){
              that.chuanjie = item.comment;
          }
      })
    });

  }

  ngAfterViewInit(){

    // if(this.mode == 1){
    //
    //     this.commonService.initPage();
    //
    // }else if(this.mode == 2){
    //
    //     this.commonService.initPage({
    //         backgroundColor:'#f0f2f6'
    //     });
    //
    // }
    let that = this;
    this.commonService.initPage();
    $(document).ready(function(){
      // 检查是否完成
      if(that.questionsGroup && that.questionsGroup.length > that.questionIndex){
        that.initCardBack();
        that.initSlideEvent();
        that.setTransitionEnd();
        // 已经回答问题的css
        // q: question
        // o: option
        that.questions.forEach(function(q, i) {
          if(q.option.length > 0){
            q.option.forEach(function(o, j){
              // 如果问题已经选择, 而且问题大于2个, 滑到全部长度
              if(o.select && q.option.length > 2 || o.select && q.length == 2){
                $('#optionColor_' + i + '_' + j).css({
                  opacity: 1,
                  width: '100%'
                });
              }else if(o.select && q.option.length == 2){
                $('#optionColor_' + i + '_' + j).css({
                  opacity: 1,
                  width: '2.8rem'
                });
              }
            });
          }
        });
        // 设置卡片位置
        that.setCardsPosition(0);
        that.checkCompleted();
      }
    });

  }

  // 初始化问题
  questionsInit(){
    // console.log(this.lesson);
    let that = this;
    this.questionsGroup = this.lesson.questionsGroup;
    // let html = '';
    // if(this.questionsGroup){
    //   for(let i = 0, len = this.questionsGroup[0].questions.length;i<len;i+=1 ){
    //     if(this.questionsGroup[0].questions[i].type =='单选题'){
    //       html = '<font color="#4CA5D2"><b>【单选题】</b></font>';
    //     }else if(this.questionsGroup[0].questions[i].type =='多选题'){
    //       html = '<font color="#E06643"><b>【多选题】</b></font>';
    //     }else{
    //       html = '【输入题】';
    //     }
    //     this.questionsGroup[0].questions[i].content = html+this.questionsGroup[0].questions[i].content;
    //   }
    // }
    setTimeout(function(){
      // console.log(that.lesson.speed);
      if((that.lesson.speed == 0 && !that.lesson.hasMultiLesson)||(that.lesson.hasMultiLesson && that.videoIndex <= that.lesson.externalId.length - 1)){
        if(that.questionsGroup && that.questionsGroup.length != that.questionIndex){
          if(that.questionsGroup[that.questionIndex].afterClass != 2){
            that.guideAnimate();
          }
        }else{
          // 如果已经完成, 通过调用api查看是否已经点入精华笔记, 如果没有, 跳入蒙版, 否则直接给出情景模拟链接
          if(that.lessonIndex == that.course.lessons.length - 1){
            that.onExit.emit(true);
          }else{
            that.guideAnimate();
          }
        }
      }else{
        // 一定是视频在最后
        // if(that.lesson.speed == 2 && that.lesson.hasPreLesson){
        //      that.guideAnimate();
        // } else{}
      }
    }, 100);

    this.singleChoiceAnimate = false;
    this.multipleChoiceAnimate = false;
    this.slideAnimate = false;
    this.slideAble = true;
    this.endPosition = -1;
    this.krisna = false;
    this.questionNumberListOpen = false;
    /*this.lessonIndex = 0;
    this.questionsGroup = this.getMockQuestionsGroup();
    this.questions = this.questionsGroup[this.questionIndex].questions;
    this.transitionText = this.questionsGroup[this.questionIndex].transition;
    this.allQuestionsNumber = this.questions.length;*/
    if(this.questionsGroup && this.questionsGroup.length > this.questionIndex){
//else{
      //
      //   return;
      // }
      // 获得问题
      // 如果是前测，先考虑是否弹出左右滑动提示
      if(this.questionIndex == 0 && this.lesson.hasPreLesson){

        this.apiService.ajax({
          'type':'get',
          'url': '/sr/onceino/102',
          'data':{}
        }).subscribe(result=>{

          if(!result){

            // setTimeout(function () {

                $("#shade2").fadeIn();
                document.getElementById('shade2').ontouchmove = function(e){ e.preventDefault(); }
                document.getElementById('slideTipPic1').ontouchmove = function(e){ e.preventDefault(); }
                document.getElementById('slideTipText').ontouchmove = function(e){ e.preventDefault(); }
                document.getElementById('slideTipButton').ontouchmove = function(e){ e.preventDefault(); }

            // }, 800);

          }

        });

      }
      this.questions = this.lesson.questionsGroup[this.questionIndex].questions;
      this.preLength = this.questionsGroup.filter(d => d.afterClass == 2).length;
      this.postLength = this.questionsGroup.length - this.preLength;
      this.transitionText = this.lesson.questionsGroup[this.questionIndex].transition;
      this.allQuestionsNumber = this.questions.length;

      this.currentNumber = 1;
      this.firstEntry = true;
      this.backface = [];
      this.setCurrentNumber = true;

      // 遍历问题
      // q: 问题
      // o: option
      if((this.preLength - 1 ) > this.questionIndex){

        this.morePreQuestions = true;
        this.moreQuestions = false;

      } else if((this.preLength - 1) == this.questionIndex){

        this.morePreQuestions = false;
        this.moreQuestions = false;

      }else if((this.questionsGroup.length - 1) > this.questionIndex && this.preLength - 1 < this.questionIndex){

        this.moreQuestions = true;
        this.morePreQuestions = false;


      } else if((this.questionsGroup.length - 1) == this.questionIndex){

        this.moreQuestions = false;
        this.morePreQuestions = false;

      }
      this.questions.forEach(function(q, i){

        q.selected = false;
        q.selectable = true;
        q.selectedOption = '';
        q.iconShow = false;
        q.analysis = "<span>【答案解析】</span>" + q.analysis.replace("【答案解析】", "");
        q.answerShow = q.answer.join('，');
        if(q.option.length > 0){
          q.option.forEach(function(o, j) {
            // 已经选择
            if(o.select == true){
              q.selected = true; // 题目已经选择
              q.selectable =false; // 题目不可以再选
              q.iconShow = true; // 显示结果图标
              if(q.type == '单选题'){
                q.selectedOption = o.content;
              }else if(q.type == '多选题'){
                // 如果是多选题, 用逗号分隔选项
                if(q.selectedOption == ''){
                  q.selectedOption = o.content;
                }else{
                  q.selectedOption = q.selectedOption + ',' + o.content;
                }
              }
              that.firstEntry = false;
          }
          if(q.type == '多选题'){
            o.correctAnswer = that.commonService.inArray(q.answer, o.content);
          }
        });
      } else if(q.option.length == 0 && q.type == "输入题"){
        if(q.textEnter && q.textEnter != ""){
          q.selected = true; // 题目已经选择
          q.selectable =false; // 题目不可以再选
          q.iconShow = true; // 显示结果图标
        }
      }
      // 开始时没有翻面
      that.backface.push(false);
      // 设置目前没有答的第一题, 否则从0开始
      if(that.setCurrentNumber && !q.selected){
        that.currentNumber = i + 1;
        that.setCurrentNumber = false;
      }
    });
    // 判断这组全部完成
    this.completed = this.allCompleted();
    // if(this.mode==2){
    //     setTimeout(function () {
    //         if(!that.questions[that.currentNumber-1].selectable){
    //             $('#analysis').show();
    //             $('#analysis').css({
    //                 top: '5rem'
    //             });
    //         }else{
    //             $('#analysis').hide();
    //             $('#analysis').css({
    //                 top: '15rem'
    //             });
    //         }
    //     },10);
    // }
    // console.log(this.questionsGroup);
    }
  }

  showAllContent(){
    $('.indentContent').removeClass('overflow');
    $('.indentBtn').hide();
  }

  initSlideEvent() {

    let startX,
        startY,
        moveEndX,
        moveEndY,
        X,
        Y;

    let that = this;
    $("#cards").on("touchstart", function(e){

      startX = e.originalEvent.changedTouches[0].pageX;
      startY = e.originalEvent.changedTouches[0].pageY;

    });

    $("#cards").on("touchmove", function(e){

      moveEndX = e.originalEvent.changedTouches[0].pageX;
      moveEndY = e.originalEvent.changedTouches[0].pageY;
      X = moveEndX - startX;
      Y = moveEndY - startY;

      var w = X < 0 ? X * -1 : X;     //x轴的滑动值
      var h = Y < 0 ? Y * -1 : Y;    //y轴的滑动值
      // if(w > h){
      //                  //如果是在x轴中滑动
      //   event.preventDefault();
      // }

    });
    $("#cards").on("touchend", function(e){

      moveEndX = e.originalEvent.changedTouches[0].pageX;
      moveEndY = e.originalEvent.changedTouches[0].pageY;
      X = moveEndX - startX;
      Y = moveEndY - startY;

      var w = X < 0? X * -1 : X;     //x轴的滑动值
      var h = Y < 0 ? Y * -1 : Y;    //y轴的滑动值
      // if(w > h){                   //如果是在x轴中滑动
      //
      //   event.preventDefault();
      //
      // }

      if (X > 5 && w > h) {

        that.slide('right');

      }
      else if (X < -5 && w > h) {

        that.slide('left');
      }

    });

  } // end of initSlideEvent



    //设置卡片
  initCardBack(){

    // $('.card').css({ height: '10.19rem' });
    // $('.cardFront').css({ height: '9.44rem' });
    // $('.cardBack').css({ height: '9.44rem' });
    // $('.circleBtn').css({ top: '8.6rem'});
    this.currentCardHeight = $('.cardBack').height(),
    this.currentTextHeight = $('.cardBackText').height();

    this.minHeight = parseFloat(getComputedStyle(document.documentElement).fontSize) * 1,
    this.maxHeight = parseFloat(getComputedStyle(document.documentElement).fontSize) * 2.7;
    // 设置cardBackImage高度
    for(let i=0; i<this.questions.length; i++){

      let currentAnswerHeight = $('#cardBackAnswer' + i).height(),
          imageHeight;

      imageHeight = this.currentCardHeight - this.currentTextHeight * 1.1 - currentAnswerHeight * 1.3;
      imageHeight = imageHeight > this.minHeight ?  (imageHeight < this.maxHeight ?  imageHeight: this.maxHeight) : this.minHeight;
      $('#cardBackImage' + i).css({'height': imageHeight, 'width': imageHeight * 1.45});

    }

  }

  setTransitionEnd(){

    let that = this;
    for(let i=0;i < this.currentNumber - 1;i++){

      document.getElementById("cardFront"+i).addEventListener("transitionend",function () {

        that.questions[i].iconShow = true;

      });
      document.getElementById("cardFront"+i).addEventListener("webkitTransitionEnd",function () {

        that.questions[i].iconShow = true;

      });

    }

  }

  slide(direction:string){
    if(this.onSubmitClick){
      return;
    }
    if(direction=='left' && this.currentNumber <= this.allQuestionsNumber){
      //如果题目还可选
      if(this.questions[this.currentNumber-1].selectable){
        $("#shade3").fadeIn(200, function(){
          setTimeout(function(){
            $("#shade3").fadeOut(200);
          }, 1000);
        })
        return;
      }else{
        // this.currentNumber = this.currentNumber == this.allQuestionsNumber ? this.currentNumber : this.currentNumber + 1;
        this.currentNumber += 1;
        this.setCardsPosition(1);
      }
    }else if(direction == 'right' && this.currentNumber > 1){
      this.currentNumber = this.currentNumber == 1 ? 1 : this.currentNumber - 1;
      this.setCardsPosition(1);
    }

    var slideId = this.questions[this.currentNumber-1].id || -1;

    if(slideId===186||slideId===187||slideId===88){
      $('.indentContent').addClass('overflow');
      $('.indentBtn').show();
    }else{
      $('.indentContent').removeClass('overflow');
      $('.indentBtn').hide();
    }
  }

  setCardsPosition(status){
    let active = this.currentNumber - 1;
    if(active == 0){
      $('#arrowLeft').fadeOut(200);
      if(!this.questions[active].selectable){
        $('#arrowRightGray').fadeOut(1, function(){
          $('#arrowRight').fadeIn(1);
        });
      } else{
        $('#arrowRight').fadeOut(1, function(){
          $('#arrowRightGray').fadeIn(1);
        });
      }
    } else if(active == this.allQuestionsNumber){
      $('#arrowLeft').fadeIn(200);
      $('#arrowRight').fadeOut(200);
      $('#arrowRightGray').fadeIn(200);
    } else {
      $('#arrowLeft').fadeIn(200);
      if(!this.questions[active].selectable){
        $('#arrowRightGray').fadeOut(1, function(){
          $('#arrowRight').fadeIn(1);
        });
      } else{
        $('#arrowRight').fadeOut(1, function(){
          $('#arrowRightGray').fadeIn(1);
        });
      }
    }
    if(status == 0){
      // first card
      // 初始化
      this.resetTurn();
      $('#card' + active).addClass('active');
    }else if(status == 1){
      $('.card.active').removeClass('active');
      this.overTurn();
      $(('#cardFront' + active)).show();
      $(('#card' + active)).addClass('active');
    }
  }

  guideAnimate(){
    $("#shade").fadeIn();
    $("#guide").show();
    $("#guide").animate({
      'top':'0.9rem'
    });
  }

  continue() {
    $("#tip1").fadeOut(300);
  }

  guideAnimateOut(){
  	//防止快速点击
		if(!this.getclickEnable()){
			return false;
		}else{
			this.clickEnable = false;
		}
    if(this.userType && this.lessonIndex == 1){
      $('body').css("height", "100%");
      let link = ['form', '3'];
      this.router.navigate(link);
    }else {
      if (this.questionsGroup && this.questionsGroup.length > this.questionIndex) {
        let that = this;
        $("#shade").fadeOut();
        $("#guide").animate({
          'top': '18rem'
        }, function () {
          $("#guide").hide();
          /*that.cardAnimate();*/
        });
        if (this.questionIndex == 0) {
          this.apiService.ajax({
            'type': 'get',
            'url': '/sr/onceino/102',
            'data': {}
          }).subscribe(result => {
            if (!result) {
              $("#shade2").fadeIn();
              document.getElementById('shade2').ontouchmove = function (e) {
                e.preventDefault();
              }
              document.getElementById('slideTipPic1').ontouchmove = function (e) {
                e.preventDefault();
              }
              document.getElementById('slideTipText').ontouchmove = function (e) {
                e.preventDefault();
              }
              document.getElementById('slideTipButton').ontouchmove = function (e) {
                e.preventDefault();
              }
            }
          });
        }
        if (this.preCompleted && that.course.lessons.length - 1 > that.lessonIndex) {
          if (this.preLength == 0 && this.course.lessons[this.lessonIndex + 1].hasPreLesson) {
            this.lessonIndex += 1;
            this.questionIndex = -1;
            this.lesson = this.course.lessons[this.lessonIndex];
            this.nextQuestion();
          } else if (this.preLength != 0 && this.course.lessons[this.lessonIndex + 1].hasPreLesson) {
            if (this.questionIndex == this.preLength - 1 && this.enterFromPre) {
              this.onGoToNextLesson.emit([this.lessonIndex, 0]);
            } else {
              this.lessonIndex += 1;
              this.questionIndex = -1;
              this.lesson = this.course.lessons[this.lessonIndex];
              this.nextQuestion();
            }
          } else if (this.preLength != 0 && !this.course.lessons[this.lessonIndex + 1].hasPreLesson) {
            this.onGoToNextLesson.emit([this.lessonIndex, 0]);
          }
        }
      } else if (this.course.lessons[this.lessonIndex].hasMultiLesson && this.videoIndex < this.course.lessons[this.lessonIndex].externalId.length - 1) {
        this.videoIndex += 1;
        this.onGoToNextLesson.emit([this.lessonIndex, this.videoIndex]);
      } else {
        let that = this;
        $("#shade").fadeOut();
        $("#guide").animate({
          'top': '18rem'
        }, function () {
          $("#guide").hide();
          if (that.course.lessons.length - 1 != that.lessonIndex) {
            if (that.course.lessons[that.lessonIndex + 1].hasPreLesson) {
              // console.log("go to next questions");
              that.lessonIndex += 1;
              that.questionIndex = -1;
              that.lesson = that.course.lessons[that.lessonIndex];
              that.nextQuestion();
              that.enterFromPre = true;
            } else {
              that.onGoToNextLesson.emit([that.lessonIndex + 1, 0]);
            }
          } else {
            //alert('No.1!'+that.learningPathId);
            that.apiService.ajax({
              'type': 'get',
              'url': '/ddilearner/v1/getLearningPathMetaId/' + that.learningPathId
            }).subscribe(result => {
              that.learningPathMetaId = result.data;
              //alert('No.2!'+that.learningPathMetaId);
              that.apiService.getOrCreateLearningPath(that.learningPathMetaId).subscribe(result => {
                that.learningPath = result;
                if(result.lock!==2){
                  that.goPracticeFlag = true;
                }else{
                  that.goPracticeFlag = false;
                }

                // console.log(that.learningPath);
                if (that.learningPath.subItems.length == 3) {
                  if (that.learningPath.name == '辅导') {
                    let practiceMetaId = that.learningPath.subItems[2].practiceMetaId;
                    let link = [that.learningPath.id, practiceMetaId, 'case-practice'];
                    that.router.navigate(link);
                  } else if (that.learningPath.name == '打造高效团队') {
                    let practiceMetaId = that.learningPath.subItems[2].practiceMetaId;
                    let link = ['case-practice-team', that.learningPath.id, practiceMetaId, 1, 0];
                    that.router.navigate(link);
                  } else if (that.learningPath.name == '授权') {
                    let practiceMetaId = that.learningPath.subItems[2].practiceMetaId;
                    let link = [that.learningPath.id, practiceMetaId, 'case-practice-authorization'];
                    that.router.navigate(link);
                  } else if (that.learningPath.name == '计划与组织') {
                    let practiceMetaId = that.learningPath.subItems[2].practiceMetaId;
                    let link = [that.learningPath.id, practiceMetaId, 'case-practice-p-and-o'];
                    that.router.navigate(link);
                  } else if (that.learningPath.name == '领导力精要') {
                    let link = ['learning-path', that.learningPathMetaId];
                    that.router.navigate(link);
                  } else if (that.learningPath.name == '协作') {
                    let practiceMetaId = that.learningPath.subItems[2].practiceMetaId;
                    let link = [that.learningPath.id, practiceMetaId, 'case-practice-cooperation'];
                    that.router.navigate(link);
                  }
                } else {
                  if (that.learningPath.name == '辅导') {
                    let practiceMetaId = that.learningPath.subItems[3].practiceMetaId;
                    let link = [that.learningPath.id, practiceMetaId, 'case-practice'];
                    that.router.navigate(link);
                  } else if (that.learningPath.name == '打造高效团队') {
                    let practiceMetaId = that.learningPath.subItems[3].practiceMetaId;
                    let link = ['case-practice-team', that.learningPath.id, practiceMetaId, 1, 0];
                    that.router.navigate(link);
                  } else if (that.learningPath.name == '授权') {
                    let practiceMetaId = that.learningPath.subItems[3].practiceMetaId;
                    let link = [that.learningPath.id, practiceMetaId, 'case-practice-authorization'];
                    that.router.navigate(link);
                  } else if (that.learningPath.name == '计划与组织') {
                    let practiceMetaId = that.learningPath.subItems[3].practiceMetaId;
                    let link = [that.learningPath.id, practiceMetaId, 'case-practice-p-and-o'];
                    that.router.navigate(link);
                  } else if (that.learningPath.name == '领导力精要') {
                    let link = ['learning-path', that.learningPathMetaId];
                    that.router.navigate(link);
                  } else if (that.learningPath.name == '协作') {
                    let practiceMetaId = that.learningPath.subItems[3].practiceMetaId;
                    let link = [that.learningPath.id, practiceMetaId, 'case-practice-cooperation'];
                    that.router.navigate(link);
                  }
                }
              });
            });
          }
        });
      }
    }
  }

  returnHome(){
    this.onExit.emit(true);
  }

  cardAnimate(){

    let that = this;
    $("#head").show();
    $("#head").animate({
        'top':'0'
    },1000);
    setTimeout(function () {

      for(let i=0;i<3;i++){

        document.getElementById("cardFront" + i).style.transform="scale(1) rotateY(0deg)";
        document.getElementById("cardBack" + i).style.transform="scale(1) rotateY(-180deg)";
        document.getElementById("cardFront" + i).style.opacity="1";
        document.getElementById("cardBack" + i).style.opacity="1";

      }

    },1000);
    setTimeout(function () {

      $("#cardBtn").show();
      $("#cardBtn").animate({
          'bottom':'0.3rem'
      },1000);
      // for(let i=0;i<3;i++){
      //     /*document.getElementById("cardFront"+i).style.transition='';
      //     document.getElementById("cardBack"+i).style.transition='';*/
      // }

    },2000);
    setTimeout(function () {

      if(that.firstEntry&&that.lessonIndex==0){

        $('#shade').fadeIn();
        $('#slideTipPic1').fadeIn();
        $('#slideTipText').fadeIn();
        $('#slideTipButton').fadeIn();

      }
      that.firstEntry = false;

    },3000);

  }

  slideTipOut(){

    $('#shade2').fadeOut();
    $('#slideTipPic1').fadeOut();
    $('#slideTipText').fadeOut();
    $('#slideTipButton').fadeOut();
    this.apiService.ajax({
        'type':'post',
        'url': '/sr/onceino/102',
        'data':{}
    }).subscribe(result=>{

    });

  }

  overTurn(){
    $("#cardFront" + (this.currentNumber - 1)).show();
    if(this.currentNumber <= this.questions.length){
      document.getElementById("cardFront" + (this.currentNumber - 1)).style.transform="rotateY(0)";
      document.getElementById("cardBack" + (this.currentNumber - 1)).style.transform="rotateY(-180deg)";
      this.backface[this.currentNumber - 1] = false;
    }
  }

  resetTurn(){
    for(let i=0; i<this.questions.length; i++){
      // 不知道这个要不要加
      $("#cardFront" + i).show();
      document.getElementById("cardFront" + i).style.transform="rotateY(0)";
      document.getElementById("cardBack" + i).style.transform="rotateY(-180deg)";
      // document.getElementById("circleBtn").style.transform="rotateY(360deg)";
      this.backface[i] = false;
    }
  }

  allCompleted(){
    let temp = false;
    this.questions.forEach(function(item, index){
      temp = temp||item.selectable;
    });
    if(this.questionIndex == this.preLength - 1 && !temp){
      this.enterFromPre = true;
    }
    return !temp;
  }

  onCircleBtnClick(i){
    if(this.questions[i].selectable && this.questions[i].selected){
      this.onSubmitClick = true;
      // $('#cardBack' + (this.currentNumber - 1)).show();
      document.getElementById("cardFront" + i).style.transform="rotateY(-180deg)";
      // document.getElementById("circleBtn" + (this.currentNumber - 1)).style.transform="rotateY(-180deg)";
      document.getElementById("cardBack" + i).style.transform="rotateY(0)";
      // document.getElementById("circleBtn" + (this.currentNumber - 1)).style.transform="rotateY(0)";
      // document.getElementById("circleBtn").style.transform="rotateY(360deg)";
      $('#cardFront' + i).hide();
      // this.questions[this.currentNumber - 1].selectable = false;
      // this.backface[this.currentNumber - 1] = true;
      if(this.questions[i].type == "输入题"){
        // 输入不能为空
        if(this.ajaxAnswer == ""){
          return;
        }
        this.questions[i].textEnter = this.ajaxAnswer;
      }

      this.commitQuestion({'lessonsQuestionsId':this.questions[i].id,'selector':this.ajaxAnswer}).then(result=>{
        $("#arrowRightGray").fadeOut(10, function(){
          $("#arrowRight").fadeIn(10);
        });
        this.onSubmitClick = false;
        this.questions[i].selectable = false;
        this.backface[i] = true;
        this.completed = this.allCompleted();
        if(this.completed){
          // 课后练习完成
          if(this.questionIndex == this.preLength - 1){
            // 如果做完前测， 标记当前视频可以观看
            this.course.lessons[this.lessonIndex].status = 4;
          }
          if(this.questionIndex == this.questionsGroup.length - 1 && this.questionIndex !== this.preLength - 1){
            this.onResetLessonStatus.emit(this.lessonIndex);
          }else{
            this.onResetQuestionStatus.emit([this.lessonIndex, this.questionIndex]);
          }
        }
        this.questions[i].iconShow = true;
      }).catch(error=>{
        console.log(error);
      });

      // 问题做完就出现
    }else if(!this.questions[i].selectable){
      if(!this.backface[i]){
        document.getElementById("cardFront" + i).style.transform = "rotateY(-180deg)";
        document.getElementById("cardBack" + i).style.transform = "rotateY(0)";
        $('#cardFront' + i).hide();
      }else{
        let cardFront = $('#cardFront' + i);
        document.getElementById("cardBack" + i).style.transform = "rotateY(-180deg)";
        $('#cardFront' + i).show();
        cardFront.find(".cardOptionItemWrap").hide();
        document.getElementById("cardFront" + i).style.transform = "rotateY(0)";
        cardFront.find(".cardOptionItemWrap").show();
      }
      this.backface[i] = !this.backface[i];
      /*this.questions[this.currentNumber-1].selectable=false;*/
      this.completed = this.allCompleted();
    }
  }

  // onLongModeBtnClick(){
  //   if(this.questions[this.currentNumber - 1].selectable && this.questions[this.currentNumber-1].selected){
  //
  //     this.questions[this.currentNumber - 1].selectable=false;
  //     this.apiService.ajax({
  //       'type':'post',
  //       'url': '/api/lessonQuestion',
  //       'data':{
  //           'lessonQuestionId':this.questions[this.currentNumber - 1].id,
  //           'select':this.ajaxAnswer
  //       }
  //     }).subscribe(result=>{});
  //     this.completed = this.allCompleted();
  //     if(this.completed == true){
  //       if(this.questionIndex == this.questionsGroup.length - 1){
  //
  //         this.onResetLessonStatus.emit(this.lessonIndex);
  //
  //       }else{
  //
  //         this.onResetQuestionStatus.emit([this.lessonIndex,this.questionIndex]);
  //
  //       }
  //     }
  //     $('#analysis').show();
  //     $('#analysis').animate({
  //
  //       top: '5rem'
  //
  //     });
  //
  //   }else if(!this.questions[this.currentNumber - 1].selectable && this.currentNumber<this.questions.length && !this.completed){
  //
  //     this.currentNumber +=1;
  //     this.completed = this.allCompleted();
  //     $('#analysis').hide();
  //     $('#analysis').css({
  //
  //       top: '15rem'
  //
  //     });
  //
  //   }else if(!this.questions[this.currentNumber - 1].selectable && this.completed){
  //
  //     if(this.questionsGroup.length-1>this.questionIndex){
  //
  //       this.completed = this.allCompleted();
  //       console.log('hahaha');
  //       this.questionIndex++;
  //       this.questionsInit();
  //
  //     }else if(this.questionsGroup.length-1==this.questionIndex){
  //
  //       this.nextLesson();
  //
  //     }
  //     this.completed = this.allCompleted();
  //     $('#analysis').hide();
  //     $('#analysis').css({
  //
  //       top: '15rem'
  //
  //     });
  //   }
  // }

  commitQuestion(data){
    return this.apiService.ajax({
      'type':'post',
      'url': '/ddilearner/v1/lessonQuestion',
      'data': data
    }).toPromise();
  }

  nextLesson(){
  	//防止快速点击
		if(!this.getclickEnable()){
			return false;
		}else{
			this.clickEnable = false;
		}
    if(this.status == 1 || this.status != 1 && this.lessonIndex == 0){

     // 如果本课没有前测， 而且下一课没有前测，那么一定触发下一课视频
     // 如果本课没有前测，而且下一课有前测，那么一定触发下一课前测
     // 如果本课有前测， 而且下一课也没有前测:
     //     如果前测的问题已经答完而进行触发: 那么进入视频， 在本课
     //     如果前测的问题答完, 而且视频或者课后练习完成进行触发: 那么进入下一课
     // 如果本课有前测, 而且下一课也有前测：
     //     如果前测的问题已经答完而进行触发: 那么进入视频， 在本课
     //     如果前测的问题答完, 而且视频或者课后练习完成进行触发: 那么进入下一前测
     if(this.preLength == 0 && !this.course.lessons[this.lessonIndex + 1].hasPreLesson){

       this.onGoToNextLesson.emit([this.lessonIndex+1, 0]);

     } else if(this.preLength == 0 && this.course.lessons[this.lessonIndex + 1].hasPreLesson){

         this.preCompleted = true;
         // this.lessonIndex += 1;
         // this.questionIndex = -1;
         // this.lesson = this.course.lessons[this.lessonIndex];
         // this.nextQuestion();
         this.enterFromPre = true;
         // $("#nextWrap").fadeOut(200);
         // $("#nextWrap").css({ bottom: '-0.9rem'});
         if(this.questionsGroup){
            this.transitionText = this.course.lessons[this.lessonIndex].preTransition;
         }
         this.guideAnimate();

     } else if(this.preLength != 0 && !this.course.lessons[this.lessonIndex + 1].hasPreLesson){

       // 还有后测
       if(this.questionIndex == this.preLength - 1 && this.enterFromPre){

         // 标记从前测进入了视频
         this.enterFromPre = false;
         // this.enterFromPre = false;
         // this.guideAnimate();
         this.preCompleted = true;
         // $("#nextWrap").fadeOut(200);
         // $("#nextWrap").css({ bottom: '-0.9rem'});
         this.guideAnimate();

       } else {

         this.onGoToNextLesson.emit([this.lessonIndex + 1, 0]);

       }

     } else if(this.preLength != 0 && this.course.lessons[this.lessonIndex + 1].hasPreLesson){

       if(this.questionIndex == this.preLength - 1 && this.enterFromPre){

        this.preCompleted = true;
        // $("#nextWrap").fadeOut(200);
        // $("#nextWrap").css({ bottom: '-0.9rem'});
        this.guideAnimate();
         // this.enterFromPre = false;

       } else {

         this.preCompleted = true;
         // $("#nextWrap").fadeOut(200);
         // $("#nextWrap").css({ bottom: '-0.9rem'});
         this.transitionText = this.course.lessons[this.lessonIndex].preTransition;
         this.guideAnimate();

       }

     }

   }else if(this.status!=1&&this.lessonIndex==1){

     let link = ['form', '3'];
     this.router.navigate(link);

   }

  }
	nextQuestionNoRepeat(){
		//防止快速点击
		if(!this.getclickEnable()){
			return false;
		}else{
			this.clickEnable = false;
		}
		this.nextQuestion();
	}
  nextQuestion(){
    let  that = this;
    // reset all current status before the next lesson
    // $("#nextWrap").fadeOut(200);
    // $('.card').css({ height: '11.09rem' });
    // $('.cardFront').css({ height: '10.34rem' });
    // $('.cardBack').css({ height: '10.34rem' });
    // $('.circleBtn').css({ top: '9.59rem'});
    // $('#nextWrap').hide();
    // $("#nextWrap").css({ bottom: '-0.9rem'});
    if($("#cardFront" + (this.currentNumber - 1)).css("display") === "none"){

      $("#cardFront" + (this.currentNumber - 1)).show();

    }
    this.questionIndex++;
    this.questionsInit();
    $("#cards").unbind();
    // $('.cards').unbind("")
    $(".card").ready(function(){

       that.setCardsPosition(0);
       that.initSlideEvent();
       that.initCardBack();
       that.setTransitionEnd();
       that.questions.forEach(function(q, i) {

         if(q.option.length > 0){
           q.option.forEach(function(o, j){

               // 如果问题已经选择, 而且问题大于2个, 滑到全部长度
               if(o.select && q.option.length > 2 || o.select && q.length == 2){

                 $('#optionColor_' + i + '_' + j).css({

                   opacity: 1,
                   width: '100%'

                 });

               }else if(o.select && q.option.length == 2){

                 $('#optionColor_' + i + '_' + j).css({

                   opacity: 1,
                   width: '2.8rem'

                 });

               }

           });
         }

       });
       that.checkCompleted();

    });
    // setTimeout(function () {
    //
    //   that.setCardsPosition(1);
    //
    // },100);

  }

  // checkAnswer(){
  //
  //   if(this.completed){
  //
  //     this.onGoToNextLesson.emit([this.lessonIndex+1, 0]);
  //
  //   }else{
  //
  //     if(this.questions[this.currentNumber-1].selectable&&this.questions[this.currentNumber-1].selected){
  //
  //       document.getElementById("cardFront" + (this.currentNumber - 1)).style.transform="rotateY(-180deg)";
  //       document.getElementById("circleBtn" + (this.currentNumber - 1)).style.transform="rotateY(-180deg)";
  //       document.getElementById("cardBack" + (this.currentNumber - 1)).style.transform="rotateY(0)";
  //       document.getElementById("circleBtn" + (this.currentNumber - 1)).style.transform="rotateY(0)";
  //
  //       this.questions[this.currentNumber-1].selectable=false;
  //       this.backface=[true,true,true];
  //       this.completed = this.allCompleted();
  //       if(this.completed == true){
  //           this.onResetLessonStatus.emit(this.lessonIndex);
  //       }
  //
  //     }
  //   }
  //}

  checkCompleted(){
    if(this.completed){
      let active = this.questions.length;
      this.resetTurn();
      $('#card' + active).addClass('active');
    }
  }

  close(){
    // console.log(this.questionsGroup.length);
    let speedArr = [];
    for(let i = 0,len =this.questionsGroup.length;i<len;i+=1){
      speedArr.push(this.questionsGroup[i].speed);
    }

    let flag = speedArr.every((item)=>{
      return item == 2;
    })

    if(flag){
      this.exit();
    }else{
      $("#tip1").fadeIn(300);
    }
    // if(this.questionsGroup.length>1){
    // }else{
    //   if(this.questionsGroup[0].speed==2){
    //     this.exit();
    //   }else{
    //     $("#tip1").fadeIn(300);
    //   }
    // }
  }

  exit(){
    // 取消选择没有提交的题目
    for(let i=0; i<this.questions.length; i++){
      if(this.questions[i].selectable){
        this.questions[i].selected = false;
        this.questions[i].selectedOption = null;
        if(this.questions[i].option.length > 0){
          this.questions[i].option.forEach(function(item, index){
            $('#optionColor_' + i + '_' + index).css({
              width: '0%',
              opacity: 0
            });
            item.select = false;
          });
        }else if(this.questions[i].option.length == 0){
           $("#textEnterChoice").val("");
        }
      }
    }
    this.onExit.emit(true);
    this.commonService.initPage();
  }

  onOptionClick(event, i, j, type){
    let that = this;
    event.stopPropagation();
    // 如果现在选项可选
    if(this.questions[i].selectable){
      if(this.questions[i].type == '单选题' && !this.singleChoiceAnimate){
        this.singleChoiceAnimate = true;
        this.questions[i].option.forEach(function (item, index){
          $('#optionColor_' + i +'_'+index).css({
            width: '0%',
            opacity: 0
          });
          item.select = false;
          if(index == j){
            item.select = true;
          }
        });
        if(type == 0){
          $('#optionColor_' + i + '_' + j).css({
            opacity: 1
          });
          $('#optionColor_' + i + '_' + j).animate({
            width: '100%'
          },10,function(){
            that.singleChoiceAnimate = false;
          });
        }else if(type == 1){
          $('#optionColor_' + i + '_' + j).css({
              opacity: 1
          });
          $('#optionColor_' + i + '_' + j).animate({
              width: '2.8rem'
          },10,function(){
              that.singleChoiceAnimate = false;
          });
        }
        this.questions[i].selected = true;
        this.questions[i].selectedOption = this.questions[i].option[j].content;
        this.ajaxAnswer = this.questions[i].option[j].content;
      }else if(this.questions[i].type == '多选题' && !this.multipleChoiceAnimate){
        if(!this.questions[i].option[j].select){
          if(this.mode == 1){
            this.multipleChoiceAnimate = true;
            $('#optionColor_' + i + '_' + j).css({
              opacity: 1
            });
            $('#optionColor_' + i + '_' + j).animate({
              width: '100%'
            }, 10, function(){
              that.multipleChoiceAnimate = false;
            });
            this.questions[i].option[j].select = true;
          }
        }else if(this.questions[i].option[j].select){
          if(this.mode == 1){
            $('#optionColor_' + i + '_' + j).animate({
                width: '0rem'
            },10,function () {
                that.multipleChoiceAnimate = false;
                $('#optionColor_' + i + '_' + j).css({
                  opacity: 0
                });
            });
            this.questions[i].option[j].select = false;
          }
        }
        let optionArray = [];
        this.questions[i].option.forEach(function (item,index){
          if(item.select){
              optionArray.push(item.content);
          }
        });
        let optionString = optionArray.join(',');
        this.ajaxAnswer = optionArray.join('|');
        this.questions[i].selectedOption = optionString;
        // console.log(this.questions[this.currentNumber-1].selectedOption);
        this.questions[i].selected = optionString == '' ? false : true;
      }
    }
  }

  onTextEnter(event, i){
    event.stopPropagation();
    if(this.questions[this.currentNumber-1].selectable){
      let enterString = $('#textEnterChoice').val();
      // let enterString = $('#textEnterChoice').val().replace(/\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F\uDE80-\uDEFF]/g,'');
      this.questions[this.currentNumber-1].selectedOption = enterString;
      this.questions[i].selected = enterString==''?false:true;
      this.ajaxAnswer = enterString;
      $('#textEnterChoice').val(this.ajaxAnswer);
    }
  }

  onQuestionNumberListHeadClick(){

    if(!this.questionNumberListOpen){

      for(let i=0;i<this.questions.length;i++){

        let top = 1.6+i;
        $("#questionNumberListNumber"+i).animate({
            top: top+'rem'
        })

      }
      this.questionNumberListOpen = true;

    }else{

      for(let i=0; i<this.questions.length; i++){
          $("#questionNumberListNumber"+i).animate({
              top: '0.45rem'
          })
      }
      this.questionNumberListOpen = false;

    }

  }

  onQuestionNumberListNumberClick(index){

    let that = this;
    this.currentNumber = index + 1;
    for(let i=0;i<this.questions.length;i++){

      $("#questionNumberListNumber"+i).animate({
          top: '0.45rem'
      })

    }
    this.questionNumberListOpen = false;

    if(!this.questions[this.currentNumber-1].selectable){

      $('#analysis').show();
      $('#analysis').css({
          top: '5rem'
      });
    } else{
      $('#analysis').hide();
      $('#analysis').css({
          top: '15rem'
      });

    }

  }

  // getMockQuestionsGroup() {
  //    return [
  //         {
  //             "transition":"知道了辅导很重要，了解了辅导的三种类型。接下来，借用你的火眼金睛，看一下练习中的五位下属，需要用到哪种类型的辅导？",
  //             "questions":[
  //                 {
  //                     "id":1,
  //                     "lesson_id":1,
  //                     "groupId":1,
  //                     "content":"小凯在你的团队负责给客户安排物流。这个月，你接到2、3起客户投诉，抱怨小凯没能及时响应客户的需求，导致生产延误。这时，你应该进行：",
  //                     "analysis":"没能及时响应客户需求，是绩效下滑的典型表现。作为管理者，这时就需要及时进行改进型辅导，帮助下属改善问题。",
  //                     "option":[
  //                         {"content":"成功型辅导","select":false},
  //                         {"content":"改进型辅导","select":false},
  //                         /*{"content":"管理问题员工","select":false}*/
  //                     ],
  //                     "answer":["改进型辅导"],
  //                     "type":"单选题"
  //                 },
  //                 {
  //                     "id":2,
  //                     "lesson_id":1,
  //                     "groupId":1,
  //                     "content":"还是你的下属小凯。响应不及时的问题，你跟他谈了很多次，但是没什么用。客户抱怨更多了，纷纷要求换人，否则终止合作。这时，你应该进行：",
  //                     "analysis":"和小凯多次谈话，不见起色，后果还越来越严重了。这时候，“管理问题员工”是你应该采取的方法",
  //                     "option":[
  //                         {"content":"成功型辅导","select":false},
  //                         {"content":"改进型辅导","select":false},
  //                         {"content":"管理问题员工","select":false}
  //                     ],"answer":["管理问题员工"],
  //                     "type":"单选题"
  //                 },
  //                 {
  //                     "id":3,
  //                     "lesson_id":1,
  //                     "groupId":1,
  //                     "content":"技术岗的小湛下周要做一场大型内训。小湛技术扎实，对产品也熟悉。但是，他从来没给别人上过课，心里有点紧张。这个时候小湛最需要的是：",
  //                     "analysis":"当下属在承接新任务、新挑战时，事先来一场“成功型辅导”，能帮他们更成功地完成任务。",
  //                     "option":[
  //                         {"content":"成功型辅导","select":false},
  //                         {"content":"改进型辅导","select":false},
  //                         {"content":"管理问题员工","select":false}
  //                     ],
  //                     "answer":["成功型辅导","管理问题员工"],
  //                     "type":"多选题"
  //                 },
  //                 {
  //                     "id":4,
  //                     "lesson_id":1,
  //                     "groupId":1,
  //                     "content":"小轶是公司的“老人”了，他常常仗着资深，在所有人面前劈头盖脸地责骂新人。新人很沮丧，旁人很尴尬。对他的辅导，应该是：",
  //                     "analysis":"小轶对待同事的态度需要改进。",
  //                     "option":[
  //                         {"content":"成功型辅导","select":false},
  //                         {"content":"改进型辅导","select":false},
  //                         {"content":"管理问题员工","select":false}
  //                     ],
  //                     "answer":["改进型辅导"],
  //                     "type":"单选题"
  //                 },
  //                 {
  //                     "id":5,
  //                     "lesson_id":1,
  //                     "groupId":1,
  //                     "content":"小策刚毕业进公司才半年，今年年会的策划你打算交给他做。他以前有举办小型活动的经验，但第一次要负责全公司20000多人参与的年会。他觉得没什么头绪。所以，你得给他进行：",
  //                     "analysis":"“没做过”、“新任务”、“有难度”，如果你的下属碰到类似挑战，就意味着成功型辅导该登场了。",
  //                     "option":[
  //                         {"content":"成功型辅导","select":false},
  //                         {"content":"改进型辅导","select":false},
  //                         {"content":"管理问题员工","select":false}
  //                     ],
  //                     "answer":["成功型辅导"],
  //                     "type":"单选题"}
  //             ],
  //             "speed":0
  //         },
  //        {
  //            "transition":"基本原则给得好，沟通效果看得见。对这五个基本原则，你已经看得清清楚楚明明白白了吗？来做个小练习吧。",
  //            "questions":[
  //                {"id":15,"lesson_id":6,"groupId":1,"content":"向下属解释“为什么”\n\n在执行公司的决策、想法或变革时 ，要跟负责这件事的下属、受影响的员工解释原因。了解为什么做某些事能够建立信任、减少谣言，以及能够帮助人们行事时基于事实而不是假设。\n\n这用到了哪个基本原则？","analysis":"分享是主管跟下属传达信息的有效手段。这个基本原则做到位，能够减少员工对新任务、新变化的抗拒情绪。注意，作为管理者，不仅要跟下属分享事实，还要分享背后原因，这样下属会更愿意拥抱变化、乐于执行。",
  //                    "option":[{"content":"KP1 自尊","select":true},{"content":"KP2 同理心","select":false},{"content":"KP3 参与","select":true},{"content":"KP4 分享","select":false},{"content":"KP5 支持","select":false}],"answer":["KP4 分享","KP5 支持"],"type":"多选题"},
  //                {"id":16,"lesson_id":6,"groupId":1,"content":"了解事实与感受，并做出相对的回应\n\n在谈话的时候，大家都希望自己的感受没有被忽视，这样他们更愿意在讨论中跟对方分享信息。让下属感觉到你理解他们所说的话，当然你并不一定需要同意他们的观点。\n\n这用到了哪个基本原则？","analysis":"在下属表达负面情绪时，同理心尤为有用。你对他们的气恼、沮丧表示感同身受，对方也更容易卸下心里的防御盾，开诚布公地与你讨论。",
  //                    "option":[{"content":"KP1 自尊","select":false},{"content":"KP2 同理心","select":false},{"content":"KP3 参与","select":false},{"content":"KP4 分享","select":false},{"content":"KP5 支持","select":false}],"answer":["KP2 同理心"],"type":"单选题"},
  //                {"id":17,"lesson_id":6,"groupId":1,"content":"重视事实，尊重他人\n\n为了避免伤害员工的自我价值感和信心，在改进型辅导的讨论中，我们把焦点放在事实的讨论上，并避免过早地下结论。 这用到了哪个基本原则？","analysis":"人人都有被尊重、被认可的需求。用就事论事的方法，如“你能不能让我了解一下为什么会发生这件事”，要比贸然下判断“你怎么一点责任心都没有”，更能让下属感受到你对他的尊重。",
  //                    "option":[{"content":"KP1 自尊","select":false},{"content":"KP2 同理心","select":false},{"content":"KP3 参与","select":false},{"content":"KP4 分享","select":false},{"content":"KP5 支持","select":false}],"answer":["KP1 自尊"],"type":"单选题"},
  //                {"id":18,"lesson_id":6,"groupId":1,"content":"\"参与\"优先，指令靠后\n\n在提出你的点子或想法之前，先征询别人的意见，再说出你的想法，或是依别人的想法而提出你自己的想法。不要指示人们该去做什么，而是先寻求他们的参与。 这用到了哪个基本原则？","analysis":"用开放式的问题激发下属思考，参与问题和办法的讨论。由此形成的解决方案，要比你一味地下命令、给任务要有效得多。",
  //                    "option":[{"content":"KP1 自尊","select":false},{"content":"KP2 同理心","select":false},{"content":"KP3 参与","select":false},{"content":"KP4 分享","select":false},{"content":"KP5 支持","select":false}],"answer":["KP3 参与"],"type":"单选题"},
  //                {"id":19,"lesson_id":6,"groupId":1,"content":"千万别说“放着，让我来”\n\n鼓励员工分析和确定他们需要什么样的支持和帮助。不要在下属请你提供协助时自发自觉地揽活干。\n\n这用到了哪个基本原则？","analysis":"在下属不会做的时候，我们可以给予他们建议和指导，但与此同时，也要鼓励下属承担应有的责任。把下属的活揽来自己干，你还做什么管理者呢？",
  //                    "option":[{"content":"KP1 自尊","select":false},{"content":"KP2 同理心","select":false},{"content":"KP3 参与","select":false},{"content":"KP4 分享","select":false},{"content":"KP5 支持","select":false}],"answer":["KP5 支持"],"type":"单选题"}],
  //            "speed":0}
  //     ]
  //
  // }

  goToTop(){
  	window.scrollTo(0, 0);
  }
  //判断是否可以重复点击
  clickEnable:boolean = true;
  timeMeter:any;
  getclickEnable(){
  	if(this.timeMeter){
  		clearTimeout(this.timeMeter);
  	}
  	this.timeMeter = setTimeout(()=>{
  		this.clickEnable = true;
  	},300);
  	return this.clickEnable;
  }

}



// WEBPACK FOOTER //
// ./src/app/course-learning-question/course-learning-question.component.ts